import { SearchTextBox } from './types/SearchTextBox';

const IndependentTab = (props) => {
    return (
        <SearchTextBox 
            {...props}
        />
    )
}

export default IndependentTab;